/** What a sound effect is, and the one helper they all use to write voices tersely. Pure. */

import type { Rand } from '../rand';
import type { Adsr, VoiceSpec, Wave } from '../voice';

/**
 * A sound effect: its voices, from a seeded variation source and one parameter (seconds left
 * for the clock tick, the count for the bonus countdown, otherwise 0). Starting times are
 * relative to the moment it is played.
 */
export type Sfx = (r: Rand, n: number) => VoiceSpec[];

/**
 * A struck voice - a ping, a thump, a crack - that dies away over `decay` seconds. The gate is
 * held through the decay, as a SID ping is played: the release begins at gate-off, so a short
 * gate would cut the decay off.
 */
export function hit(wave: Wave, freq: number, decay: number, level: number): VoiceSpec {
  return { wave, at: 0, freq, gate: decay, env: { a: 0.001, d: decay, s: 0, r: Math.min(0.05, decay * 0.25) }, level };
}

/** A plain voice starting at 0; spread extra fields (filter, glide, width ...) over it. */
export function tone(wave: Wave, freq: number, gate: number, env: Adsr, level: number): VoiceSpec {
  return { wave, at: 0, freq, gate, env, level };
}
